import { render, staticRenderFns } from "./Etapa5.vue?vue&type=template&id=760830c0&scoped=true&"
import script from "./etapa5.ts?vue&type=script&lang=ts&"
export * from "./etapa5.ts?vue&type=script&lang=ts&"
import style0 from "./Etapa5.vue?vue&type=style&index=0&id=760830c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760830c0",
  null
  
)

export default component.exports